/**
 * Parses a comma-separated list of numeric IDs.
 * @param {string|number|null|undefined} value
 * @returns {string[]} Non-empty trimmed ID strings
 */
export function parseCommaSeparatedIds(value) {
  if (value === null || value === undefined) return [];
  const str = String(value).trim();
  if (!str) return [];
  return str
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

/**
 * Validates comma-separated numeric IDs (e.g. "123" or "123, 456,789").
 * @param {string|number|null|undefined} value
 * @returns {string|undefined} Error message if invalid
 */
export function validateCommaSeparatedNumericIds(value) {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  const parts = parseCommaSeparatedIds(value);
  if (parts.length === 0) {
    return undefined;
  }

  const invalidPart = parts.find((part) => !/^\d+$/.test(part));
  if (invalidPart) {
    return "Enter numeric IDs separated by commas";
  }

  return undefined;
}
